module.exports = __webpack_public_path__ + "media/img/sda/OBS-sda-4e05c71306a0b4708092c4f8692c9d18.jpg";